/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];.item-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;font-size:14px;line-height:14px}.flag-label-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;margin-right:16px}.flag-label-wrapper[_ngcontent-%COMP%]   .iti-flag[_ngcontent-%COMP%]{margin-right:10px}.msisdn[_ngcontent-%COMP%]{color:#9da2bd}"];
export { styles as styles };
